import { createContext } from 'react';

/**
 * FE#444 — what the planner list tells its rows about "Schedule again".
 * A context rather than row props: the rows are memoised through react-window's `itemData`,
 * and putting a selection in there would re-key every row on each tick of a checkbox.
 */
export interface ScheduleAgainContextValue {
    selectMode: boolean;
    selected: ReadonlySet<string>;
    toggle: (messageId: string) => void;
    /** Open the dialog for exactly this one sent message. */
    openFor: (messageId: string) => void;
}

/** `null` outside the planner list (e.g. the same row rendered elsewhere): no selection, no action. */
export const ScheduleAgainContext = createContext<ScheduleAgainContextValue | null>(null);
